import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    cardHeader: {
      marginBottom: spacing(5),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    label: {
      color: colors.kato.neutral[900],
      fontWeight: 500,
      marginBottom: spacing(4),
    },
    divider: {
      backgroundColor: colors.grey.light,
      height: 1,
      width: '100%',
      margin: spacing(4, 0),
    },
    radioRoot: {
      marginBottom: spacing(5),
    },
    radioWrapper: {
      flex: 1,
    },
    loading: {
      marginTop: spacing(4),
    },
    checkboxes: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2.5),
    },
    noScheduleContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
    },
    addAddressButton: {
      alignSelf: 'flex-start',
    },
    addAddressButtonError: {
      alignSelf: 'flex-start',
      border: `1px solid ${colours.error[500]}`,
    },
    totalSpace: {
      display: 'flex',
      gap: spacing(4),
      flex: '1 0 auto',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    totalSpaceLabel: {
      color: colors.kato.neutral[900],
      fontWeight: 500,
    },
    metricSelect: {
      width: 120,
    },
    tenantOnScheduleContent: {
      display: 'flex',
      flexDirection: 'column',
      wrap: 'nowrap',
    },
    spaceCardHeader: {
      display: 'none',
    },
    hideAddress: {
      display: 'none',
    },
    addressContainer: {
      display: 'flex',
      gap: spacing(2),
      alignItems: 'center',
      width: '100%',
    },
    alert: {},
  });
